
(function () {
  var root = document.getElementById('AgCart');
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function openCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var lines = root.querySelector('[data-ag-lines]');
      lines.innerHTML = cart.items.map(function (item) {
        return '<div class="ag-cart__line"><img alt="" src="' + (item.image || '') + '"><div><p>' + item.product_title + '</p><p>' + money(item.final_line_price) + '</p><label>Qty <input data-ag-qty="' + item.key + '" type="number" min="0" value="' + item.quantity + '"></label></div></div>';
      }).join('') || '<p style="padding:20px">Your cart is empty.</p>';
      root.querySelector('[data-ag-subtotal]').textContent = money(cart.total_price);
      root.querySelector('[data-ag-discount]').textContent = cart.total_discount ? ('Discount ' + money(cart.total_discount)) : '';
      root.hidden = false;
    });
  }
  function closeCart() { root.hidden = true; }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-action="open-cart"], .agh__cart-link')) { event.preventDefault(); openCart(); }
    if (event.target.closest('[data-ag-close]')) closeCart();
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action="/cart/add"], form[action*="/cart/add"]')) return;
    event.preventDefault();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () {
        var toast = root.querySelector('[data-ag-toast]');
        toast.hidden = false;
        openCart();
      });
  });
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-ag-qty]');
    if (!input) return;
    var body = new URLSearchParams();
    body.set('id', input.getAttribute('data-ag-qty'));
    body.set('quantity', input.value);
    fetch('/cart/change.js', { method: 'POST', body: body }).then(function () { openCart(); });
  });
})();
